<script>
import title1 from '../assets/title-1.svg';
import title2 from '../assets/title-2.svg';

import feature01 from '../assets/feature01.png';
import feature02 from '../assets/feature02.png';
import feature03 from '../assets/feature03.png';
import feature04 from '../assets/feature04.png';

import brand_img from '../assets/brand-img.svg';

export default {
    data(){
        return {
            features:[
                {
                    img: feature01,
                    title: 'NITRUM®獨家不鏽鋼刀片',
                    txt: '提升刀具在切割、耐久與硬度等各項性能，等級同醫用手術刀，生產過程對環境友好。'
                },
                {
                    img: feature02,
                    title: '熱變形鍛造工藝',
                    txt: '一體成形鍛造刀身，更加堅固不易斷裂。鍛造刀枕設計，緊密貼合手部，有效提升持刀握感與穩定度，使用上更加舒適。'
                },
                {
                    img: feature03,
                    title: '銀離子抗菌技術',
                    txt: '降低了99.9％在刀柄表面的細菌，使用上更安全衛生。'
                },
                {
                    img: feature04,
                    title: 'NSF認證',
                    txt: '通過美國國家衛生基金會NSF (National Sanitation Foundation)認證，品質保證。'
                }
            ],
            title1,
            title2,
            brand_img,
            video_text: "ARCOS換購倒數",
            link: "https://www.youtube.com/embed/ZLdAfoF3ZvI"
        }
    },
    methods: {

    },
    mounted(){

        setTimeout(()=>{
            $('#main-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }, 1000);
        setTimeout(()=>{
            $('#main-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }, 1500);
        setTimeout(()=>{
            $('#main-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
        }, 2000);
        console.log("BDIntro!!")

    }
}

</script>

<template>
    <section class="brand-intro" id="brand-intro">

        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="video-box-wrap">
                        <div class="video-box">
                            <!-- <iframe id="video" src="https://www.youtube.com/embed/i7-CkbK8VBM?enablejsapi=1&html5=1&rel=0&amp;autoplay=0&mute=1&playsinline=1" frameborder="0" allowfullscreen></iframe> -->
                            <iframe id="main-video" :src="`${link}?autoplay=1&mute=1&enablejsapi=1&version=3&playerapiid=ytplayer&playsinline=1`" allow="autoplay" frameborder="0" allowfullscreen></iframe>
                            <!-- <img :src="cf" alt=""> -->
                        </div>
                        <p class="video-text">{{video_text}}</p>
                    </div>
                </div>
            </div>
            <div class="row brand">
                <div class="col-12">
                    <div class="content-wrap">
                        <div class="title-img">
                            <img :src="title1" alt="">
                        </div>
                        <div class="img-wrap">
                            <img :src="brand_img" alt="">
                        </div>
                        <h4 class="title">西班牙超越300年的榮譽，米其林名廚最愛刀具品牌</h4>
                        <p class="text">
                            ARCOS起源於1734年，是西班牙最具代表性且最古老的刀具品牌。承載300年歷史的ARCOS，多款優秀作品收藏在西班牙國家歷史博物館，並持續不斷致力於創新與設計，品牌獲獎無數，在廚用刀具上代表著西班牙原產最高榮譽。獨家採用高性能的NITRUM ®專利不鏽鋼材質和技術，大幅提升刀具在切割與耐久抗蝕等各項性能，ARCOS秉持著刀具製作的嚴謹傳統，始終專注在提升刀具品質，在每一個微小的細節上，為使用者細細琢磨各式廚用刀具的需求，在每一個環節也致力達成環境永續及社會責任的目標，使ARCOS達到最高成就，不僅取得ISO認證與NSF等品質及安全認證，也在設計獎項上履獲肯定，成為銷售全球70多國著名的專業刀具。
                        </p>
                    </div>

                    <!-- <div class="video-box-wrap">
                        <div class="video-box">
                            <div class="play-btn"></div>
                            <iframe id="brand-video" src="https://www.youtube.com/embed/i7-CkbK8VBM?enablejsapi=1&html5=1&rel=0&amp;autoplay=0&mute=1&playsinline=1" frameborder="0" allowfullscreen></iframe>
                        </div>
                        <p class="video-text">全聯福利中心BOGO FREE DANCE 買一送一</p>
                    </div> -->

                </div>
                

            </div>
            <div class="row features">
                <div class="col-12 col-md-6 col-lg-3 feature" v-for="item in features">
                    <div class="img-outer">
                        <div class="img-wrap">
                            <img :src="item.img" alt="">
                        </div>
                    </div>
                   
                    
                    <h6 class="title">{{item.title}}</h6>
                    <p class="txt">{{item.txt}}</p>
                </div>
            </div>

            <div class="row chief">
                <div class="col-12 col-lg-8 offset-lg-2">
                    <div class="content-wrap">
                        <div class="title-img">
                            <img :src="title2" alt="">
                        </div>
                        <div class="img-wrap">
                            <img src="../assets/chief.jpg" alt="">
                        </div>
                    </div> 
                </div>
                <div class="col-12">
                    <div class="content-wrap">
                        <h4 class="title">西班牙米其林二星主廚-馬力歐 ‧ 桑多瓦爾(Chef Mario Sandoval) 流淌在血液中的廚藝，擅長傳承與前衛衝擊的料理風格</h4>
                        <p class="text">
                            西班牙美食界的當紅寵兒馬力歐 ‧ 桑多瓦爾，來自餐飲世家三代傳承─其所經營的Coque餐廳即是以祖父的名字命名，10歲的他因家族而愛上烹飪，並在26歲就獲得第一顆米其林星，於一年後，贏得西班牙國際美食大獎最佳廚師冠軍，之後更於2015年摘下了米其林二星的肯定。即使年紀輕輕即才華橫溢，在廚藝追求上他從不停歇，進修藍帶課程並在多家餐廳名店跟隨名師學習，這期間出版多本書藉，獲得西班牙為數眾多的廚藝競賽頭銜。
                            <br>
                            <br>
                             “我想創造出具有特色、原創性及感官平衡的菜餚，這些菜餚將被人們記住。”他致力創造馬德里這繁華城市的美食體驗，很清楚自己想在作品中體現什麼，它從傳統中汲取靈感，但以創新，前衛，藝術的方式塑造。其所共同提倡及推行的#TopTapas活動，旨在宣揚西班牙Tapas飲食文化，被聯合國教科文組織宣佈為非物質文化遺產。馬力歐在創新同時，也致力宣揚西班牙美食文化的初衷，積極的行動也使他成為西班牙美食界的當紅寵兒。
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="sass">



@import "../sass/global.sass"
.brand-intro
    overflow: hidden
    position: relative
    background-image: url('../assets/mosaic.png')
    background-position-x: center 
    // background-size: cover
    padding-top: 80px
    padding-bottom: 80px
    @media (max-width: 991px)
        // margin-bottom: 70px
        padding-top: 80px
        padding-bottom: 80px
    @media (max-width: 768px)
        padding-top: 50px
        padding-bottom: 50px
    @media (max-width: 576px)
        padding-top: 40px
        padding-bottom: 40px

    .title-img 
        text-align: center
        margin-bottom: 56px
        img
            width: 176px
    .features
        padding-left: 30px
        padding-right: 30px
        padding-bottom: 80px
        .feature
            color: #ffffff
            @media (max-width: 576px)
                padding-left: 0
                padding-right: 0
                // margin-bottom: 24px
            .img-outer
                padding: 64px 40px
                max-width: 500px
                @media (max-width: 768px)
                    max-width: 300px
                    margin: 0 auto
                    // padding: 40px
                .img-wrap
                    text-align: center
                    width: 100%
                    height: 0
                    padding-bottom: 100%
                    overflow: hidden
                    img
                        width: 100%
                        
            .title
                text-align: center
                font-weight: 400
                background: $red
                padding: 12px 8px
                border-radius: 12px
                font-size: 18px

    .brand
        // padding-bottom: 100px
        .img-wrap
            text-align: center
            margin-bottom: 45px
            @media (max-width: 991px)
                margin-bottom: 40px
            img
                width: 40%
                margin: 0 auto
                max-width: 446px
                min-width: 280px
        
    .chief
        .content-wrap
            .img-wrap
                width: 100%
                padding-bottom: 68%
                height: 0
                overflow: hidden
                margin-bottom: 0
                img
                    width: 100%

    .content-wrap
        //max-width: 50%
        // background-color: #ab1212
        margin: 0 auto
        text-align: left
        padding-top: 50px
        // padding-bottom: 70px
        border-radius: 30px
        padding-left: 30px
        padding-right: 30px
        @media (max-width: 991px)
            //max-width: 80%
            padding-top: 50px
            padding-bottom: 50px
        @media (max-width: 768px)
            max-width: 100%
        @media (max-width: 576px)
            padding: 30px 15px
        .img-wrap
            text-align: center
            margin-bottom: 45px
            @media (max-width: 991px)
                margin-bottom: 40px
            // img
            //     width: 40%
            //     margin: 0 auto
            //     max-width: 446px
            //     min-width: 340px
                // @media (max-width: 768px)
                //     min-width: 380px
                // @media (max-width: 576px)
                //     min-width: 240px
                //     max-width: 200px

        .text
            line-height: 30px
            color: #fff
            letter-spacing: 2px
            font-weight: 300
            font-size: 18px
            text-align: justify
        .title
            color: $red
            font-weight: 400
            letter-spacing: 2px
            line-height: 1.5
            // margin-top: 40px
    .video-box-wrap
        margin: 0 auto
        max-width: 50%
        margin-bottom: 50px
        @media (max-width: 991px)
            max-width: 70%
        @media (max-width: 768px)
            max-width: 100%
            //padding-bottom: 56.25%
        .video-box
            padding-bottom: 56.25%
            position: relative
            border-bottom: none

            border: 5px solid #000
            iframe, img
                background: black
                position: absolute
                display: block
                top: 50%
                left: 50%
                transform: translate(-50%, -50%)
                width: 100%
                height: 100%

        .video-text
            background: black
            padding: 15px 10px
            text-align: center
            color: white
            font-size: 18px
            letter-spacing: 1px
            @media (max-width: 576px)
                font-size: 14px



</style>



// WEBPACK FOOTER //
// src/Index/BrandIntro.vue